var Backbone = require('backbone');


module.exports = Backbone.Model.extend({

    defaults: {

        selectedShape: null, //only one shape can be selected on canvas at a time, when true, is selected and all others unselected  -- shape has isSelected prop.
        editMode: false,  // true if can draw -- opens into 'non edit' mode (toggled on activeNote changed)
        isDrawing: false /* necessary -- base entering the draw can occur mult times  (OR DISABLE/ENABLE THE INITIAL MOUSEDOWN -- also broadcast to page note view */

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/canvas.state.js
 ** module id = 358
 ** module chunks = 0
 **/